import React, { useEffect, useState } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import colors from 'config/colors';
import fonts from 'config/fonts';
import spacing from 'config/spacing';

import Button from 'components/Button';
import Logo from 'components/Page/Logo';

import AcceptanceDocuments from './AcceptanceDocuments';
import { fieldStyles } from './field-styles';

const styles = {
  button: {
    border: '0px solid black',
    color: colors.white,
    padding: spacing.base,
    borderRadius: spacing.tiny,
    width: '100%',
    fontSize: fonts.sub.size,
  },
  resetButton: {
    border: '0px solid black',
    color: colors.white,
    padding: spacing.base,
    borderRadius: spacing.tiny,
    width: '35%',
    fontSize: fonts.sub.size,
    margin: 10,
  },
  forgotButton: {
    border: 'none',
    color: colors.text,
    backgroundColor: colors.white,
    fontSize: '0.9rem',
    fontWeight: 'normal',
  },
  message: {
    textAlign: 'center',
    padding: 12,
    paddingTop: 0,
  },
  loginContainer: {
    flex: 1,
  },
  passwordField: {
    position: 'relative',
    marginTop: 6,
    marginBottom: 24,
  },
  passwordVisibilityButton: {
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    color: colors.lightText,
    cursor: 'pointer',
    display: 'flex',
    height: 40,
    justifyContent: 'center',
    padding: 0,
    position: 'absolute',
    right: 5,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 40,
  },
};

const stopSubmit = (cb) => {
  return (ev) => {
    ev.preventDefault();
    cb();
    return false;
  };
};

const LoginForm = (props) => {

  const [passwordIsVisible, setPasswordIsVisible] = useState(false);

  useEffect(() => {
    if (!passwordIsVisible) return undefined;

    const hidePasswordTimeout = setTimeout(() => setPasswordIsVisible(false), 5000);
    return () => clearTimeout(hidePasswordTimeout);
  }, [passwordIsVisible]);

  const hasUnacceptedDocuments = props.acceptanceDocuments?.some(doc => !doc.isAccepted);
  const disabled = !props.formValues.email || !props.formValues.password || hasUnacceptedDocuments;

  const login = () => {
    if (!disabled && props.login) props.login();
  };

  return (
    <form method="post" style={styles.loginContainer} onSubmit={stopSubmit(login)}>
      <div style={{ textAlign: 'center', margin: 24 }}>
        <Logo size={130} />
      </div>
      {/* {props.message ? <p style={styles.message}>{props.message}</p> : null} */}
      <div>
        {/* <label htmlFor="login-email" style={{ fontSize: '1.1rem', fontWeight: 500 }}>
          Email Address
        </label> */}
        <input
          id="login-email"
          type="email"
          autoComplete="email"
          disabled={!!props.emailDisabled}
          style={{ ...fieldStyles.input, marginTop: 6, marginBottom: 24 }}
          placeholder="Email Address"
          value={props.formValues.email}
          onChange={event => props.setFormValue('email', event.target.value)}
        />
        {/* <label htmlFor="login-password" style={{ fontSize: '1.1rem', fontWeight: 500 }}>
          Password
        </label> */}
        <div style={styles.passwordField}>
          <input
            id="login-password"
            type={passwordIsVisible ? 'text' : 'password'}
            autoComplete="current-password"
            style={{ ...fieldStyles.input, marginBottom: 0, paddingRight: 48 }}
            placeholder="Password"
            value={props.formValues.password}
            onChange={event => props.setFormValue('password', event.target.value)}
          />
          <button
            type="button"
            aria-label={passwordIsVisible ? 'Hide password' : 'Show password'}
            aria-pressed={passwordIsVisible}
            title={passwordIsVisible ? 'Hide password' : 'Show password'}
            style={styles.passwordVisibilityButton}
            onClick={() => setPasswordIsVisible(isVisible => !isVisible)}
          >
            {passwordIsVisible ? <MdVisibilityOff size={22} /> : <MdVisibility size={22} />}
          </button>
        </div>
      </div>

      {!!props.acceptanceDocuments?.length && (
        <div style={{ paddingTop: 6, paddingBottom: 6 }}>
          <AcceptanceDocuments displayAcceptanceDocument={props.displayAcceptanceDocument} acceptanceDocuments={props.acceptanceDocuments} />
        </div>
      )}

      <Button black huge shadow={false} fullWidth submit disabled={disabled} style={{ fontSize: 16, marginBottom: 4 }}>
        Login
      </Button>

      {!!props.forgotPassword && (
        <div style={{ textAlign: 'center' }}>
          <Button small shadow={false} style={styles.forgotButton} onClick={props.forgotPassword}>
            Forgot your password?
          </Button>
        </div>
      )}
    </form>
  );
};

export default LoginForm;
